export const CHART_HEIGHT_IN_REPORT_VIEW = '100%';
